import { variant } from 'styled-system'

const textVariant = variant({
  prop: 'variant',
  variants: {
    small: {
      fontSize: 10,
    },
    caption: {
      fontSize: 12,
      lineHeight: '20px',
    },
    body: {
      fontSize: 14,
      lineHeight: '24px',
    },
    subtitle: {
      fontSize: 16,
      lineHeight: '27px',
    },
    heading3: {
      fontSize: 20,
    },
    heading2: {
      fontSize: 24,
    },
    heading1: {
      fontSize: 32,
    },
  },
})

const weightVariant = variant({
  prop: 'weight',
  variants: {
    bold: {
      fontWeight: '700',
    },
    regular: {
      fontWeight: '400',
    },
    semibold: {
      fontWeight: '600',
    },
  },
})

export { textVariant, weightVariant }
